import { FaPhoneAlt } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import salesImg from "../images/Customer/A1.jpg"

const SalesPersonCard = () => {
  return (
    <div className="sales-person-card">
        <div className="sales__person-info">
      <img
        src={salesImg} // replace with actual agent image
        alt="Sales Person"
        className="agent-image"
      />
      <div>
      <h4 className="agent-title">Peace Doyle</h4>
      <p className="agent-role">Sales Admin</p>

      </div>

        </div>

      <div className="agent-actions">
        <p className="agent-subtitle">Talk to our customer care agent</p>
        <div className="agent-buttons">
          {/* Call Button */}
          <a href="tel:+254713988888" className="agent-btn call-btn">
            <FaPhoneAlt /> 0713988888


          </a>

          {/* WhatsApp Button */}
          <a
            href="https://wa.me/254713988888?text=Hello%20I%20am%20interested%20in%20this%20car"
            target="_blank"
            rel="noopener noreferrer"
            className="agent-btn whatsapp-btn"
          >
            <IoLogoWhatsapp /> Start a Chat
          </a>
        </div>
      </div>
    </div>
  );
};

export default SalesPersonCard;
